import Cookies from "universal-cookie";
import APP_CONF from "../../app.conf";
//import moment from 'moment';

class _AuthenticationHandler {
  constructor(props) {
    this.props = props;
    this.accountData = {};
    this.isAuthenticated = false;
    this.view = undefined;

    this._AUTH_COOKIE_NAME = "reacto_auth";

    this.cookies = new Cookies();

    this.checkAuthentication = this.checkAuthentication.bind(this);
    this.getToken = this.getToken.bind(this);
    this.logout = this.logout.bind(this);
    this._actionShelf =
      this.props.actionsShelfService.createNewShelf("authHandlerActions");
    this._actionShelf.registerAction({
      key: "logout",
      call: this.logout,
    });
  }

  authenticate(credentials, cb) {
    let POST = {};
    if (credentials.token) {
      POST.token = credentials.token;
    }
    if (credentials.user) {
      POST.user = credentials.user;
    }
    if (credentials.email) {
      POST.email = credentials.email;
    }
    if (credentials.password) {
      POST.pwd = credentials.password;
    }

    POST.host = window.location.hostname;

    this.props.apiStoreService.fire("login", {
      data: POST,
      ___onSuccess: (status, data, error) => {
        if (status == "KO") {
          cb(status, data);
        } else {
          let wrongPlatform = false;
          let ipv4_regex =
            /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/gm;
          let isIpv4 = ipv4_regex.test(window.location.hostname);

          if (
            data.accountData.platform &&
            data.accountData.platform != "all" &&
            !isIpv4
          ) {
            if (
              this.getAllDomains().subdomain &&
              this.getAllDomains().subdomain != data.accountData.platform
            ) {
              const { tt } = data.authRegistry;
              let port = "";
              const { pathname } = window.location;
              if (window.location.port != "") port = ":" + window.location.port;
              wrongPlatform =
                data.accountData.platform +
                "." +
                this.getAllDomains().domain +
                port +
                pathname;

              window.location.href = `http://${wrongPlatform}?tt=${tt}`;
            }
          }

          // console.log(
          //   "wrongPlatform",
          //   this._AUTH_COOKIE_NAME,
          //   data.authRegistry.auth_token
          // );

          // SET CLUSTER
          this.props.apiStoreService.isCloud() &&
            data.accountData &&
            data.accountData.cluster &&
            this.props.apiStoreService.setCluster(data.accountData.cluster);
          // SET TOKEN
          data.authRegistry &&
            data.authRegistry.auth_token &&
            !wrongPlatform &&
            this.cookies.set(this._AUTH_COOKIE_NAME, data.authRegistry.auth_token, {
              path: "/",
            });
          let cluster = data.accountData.cluster; // cluster set for edge
          // POST LOGIN
          this.props.apiStoreService.fire("post_login", {
            data: { token: data.authRegistry.auth_token },
            ___onSuccess: (status, data) => {
              if (data.accountData) {
                this.accountData = { cluster: cluster, ...data.accountData };
              }
              cb(status, data, wrongPlatform);
            },
            ___onError: (status, data) => {
              cb(status, data);
            },
            ___onUnauthorized: (status, data) => {
              cb(status, data);
            },
          });
        }
      },
      ___onError: (status, data) => {
        console.log("___onError from LOGIN", status, data);
        cb(status, data);
      },
      ___onUnauthorized: (status, data) => {
        console.log("___onUnauthorized", status, data);
        cb(status, data);
      },
    });
  }

  login(credentials, cb) {
    this.authenticate(credentials, (status, data, wrongPlatform) => {
      if (status === "OK") {
        this.isAuthenticated = true;
        this.props.onLoginSuccess(this.getAccountData());
        if (cb) cb(status, data, wrongPlatform);
      } else {
        this.isAuthenticated = false;
        if (cb) cb(status, data);
      }
    });
  }

  logout(cb) {
    this.props.apiStoreService.fire("logout", {
      ___onSuccess: (status, response) => {
        this.invalidateToken(cb);
        this.props.onLogoutSuccess();
        this.isAuthenticated = false;
        if (cb) {
          cb(status, response);
        }
      },
      ___onError: (status, response) => {
        if (cb) {
          cb(status, response.error);
        }
      },
    });
  }

  invalidateToken(cb) {
    //	this.cookies.remove(this._AUTH_COOKIE_NAME, {path: '/'});
    this.isAuthenticated = false;
    if (cb) {
      cb();
    }
  }

  async fetchTT(tt) {
    const url = APP_CONF.SERVER_URL + APP_CONF.API_PATH + "/tt/" + tt;
    const res = await fetch(url);
    const data = await res.json();
    return data;
  }

  async checkAuthentication(cb) {
    let token = null;
    const urlParams = new URLSearchParams(window.location.search);
    const tt = urlParams.get("tt");
    if (tt) {
      const datares = await this.fetchTT(tt);
      token = datares.data.token;
    }

    var curr_cookie = token || this.cookies.get(this._AUTH_COOKIE_NAME);
    if (curr_cookie) {
      this.authenticate({ token: curr_cookie }, (status, data) => {
        if (status === "OK") {
          this.isAuthenticated = true;
          cb("OK");
        } else {
          this.isAuthenticated = false;
          cb("KO", data);
        }
      });
    } else {
      cb("KO", "NO_COOKIE");
    }
  }

  isAuthorized() {
    return this.isAuthenticated;
  }

  getAllDomains() {
    let subdomain;
    let domain;
    let host = window.location.hostname;
    let port = window.location.port;
    let arr = host.split(".");
    if (arr.length == 1) {
      domain = arr[0];
    } else {
      subdomain = arr.shift();
      domain = arr.join(".");
    }
    return { subdomain, domain, port };
  }

  getToken(opt) {
    return opt && opt === "x_header"
      ? this._AUTH_COOKIE_NAME + "=" + this.cookies.get(this._AUTH_COOKIE_NAME)
      : this.cookies.get(this._AUTH_COOKIE_NAME);
  }

  getAccountData() {
    return this.accountData;
  }

  signIn() {
    this.view.showSignIn();
  }
}

export default _AuthenticationHandler;
